<template>
  <a-card class="m-display-flex flex-column padding-unset">
    <span slot="title">Traveloka Claim Form</span>
    <a-row :gutter="16">
      <a-col :span="leftcolumn" class="m-page-wrapper">
        <a-card>
          <div class="step">
            <div class="step-header">
              <a-steps :current="current" status="process">
                <a-step title="Information" />
                <a-step title="Usage" />
                <a-step title="Approval" />
              </a-steps>
            </div>
            <div class="step-content">
              <component
                class="m-flex1"
                :is="steps[current].content"
                :ref="stepRef"
                v-bind="stepProps"
              ></component>
            </div>
          </div>
          <template class="ant-card-actions" slot="actions">
            <div class="steps-action">
              <a-button-group>
                <a-button v-if="current == 1 && !loading_action" type="primary" @click="handleAddDtl" :loading="loading.add" :disabled="loading.steps">
                  Add
                </a-button>
                <a-button v-if="current == 1 && loading_action" type="primary" @click="handleChange" :loading="loading.add">
                  Change
                </a-button>
                <a-button v-if="current == 1 && loading_action" type="danger" @click="handleCancel" :disabled="loading.add">
                  Cancel
                </a-button>
                <a-button
                  v-if="current == steps.length - 1"
                  type="primary"
                  :loading="loading.steps"
                  @click="saveTrans"
                >Save</a-button>
              </a-button-group>
              <a-button-group>
                <a-button v-if="current > 0" @click="prev" :disabled="loading.add || loading_action || loading.steps">Previous</a-button>
                <a-button v-if="current < steps.length - 1" type="primary" :disabled="loading.add || loading_action || loading.dtl" :loading="loading.steps" @click="next">Next</a-button>
              </a-button-group>
            </div>
          </template>
        </a-card>
      </a-col>
      <a-col :span="rightcolumn" class="m-page-wrapper">
        <a-card class="m-height-full m-display-flex flex-column">
          <div slot="title">
            <span>Reporting Details</span>
          </div>
          <template slot="extra">
            <a-button v-if="current == 1" :loading="collectiveLoading" @click="onCollective" class="margin-right-small" icon="edit">Collective</a-button>
            <a-button v-if="current == 1" @click="handleExpand()">
              <span>{{labelExpand}}</span>
            </a-button>
          </template>
          <a-table
            :rowKey="(record, index) => {return index;}"
            :columns="columns"
            :dataSource="collectData.usage"
            :pagination="pagination"
            size="small"
            class="flex-1"
            :scroll="{ x: 1700 }"
            :loading="loading.dtl"
            bordered
          >
            <template slot="customTitle">
              Action
            </template>
            <template slot="no" slot-scope="text, item, index">
              {{(pagination.page - 1) * pagination.pageSize + index + 1}}
            </template>
            <template slot="dt" slot-scope="item">
              {{ moment(item.expense_date).format(getDefaultDateFormat) }}
            </template>
            <template slot="tun" slot-scope="item">
              {{ item.type_ticket }} | {{ item.user_booking }} | {{ item.no_booking }}
            </template>
            <!-- <template slot="typeItem" slot-scope="item">
              {{ lbltype_Item(item.type_item) }}
            </template> -->
            <template slot="val" slot-scope="item">
              <CurrencyJustified
                :currencyValue="'IDR'"
                :valueNumber="item.credit"
              />
            </template>
            <template slot="bspc" slot-scope="item">
              <div v-if="item.no_sppd" :style="!item.kode_anggaran ? 'color:red!important' : ''">SPPD : {{ item.no_sppd }}</div>
              <div v-else-if="item.no_pp" :style="!item.kode_anggaran ? 'color:red!important' : ''">PP : {{ item.no_pp }}</div>
              <div v-else-if="!item.no_sppd && !item.no_pp && item.kode_anggaran" :style="!item.kode_anggaran ? 'color:red!important' : ''">ANGGARAN : {{ item.kode_anggaran }}</div>
              <div v-else class="w-full m-text-align center"><b style="color:red">Not Set</b></div>

              <div v-if="item.no_sppd || item.no_pp" :style="!item.kode_anggaran ? 'color:red!important' : ''"><small><i>Anggaran : {{ item.kode_anggaran }}</i></small></div>
              <div v-if="item.no_prospek" :style="!item.kode_anggaran ? 'color:red!important' : ''"><small><i>Prospek : {{ item.no_prospek }} - {{ item.description_prospek }}</i></small></div>
            </template>
            <template slot="ic" slot-scope="item">
              {{ item.iscommision=='1'?'Yes':'No' }}
            </template>
            <template slot="doc" slot-scope="item">
              <a-button type="default" size="small" v-if="item.lampiran" @click="handleViewDoc(item.lampiran_path)"><a-icon type="eye" />&nbsp;View</a-button>
              <span v-else>{{item.lampiran_path}}</span>
            </template>
            <template slot="desc" slot-scope="item">
              {{item.description}} <b><small>({{ lbltype_Item(item.type_item) }})</small></b>
            </template>
            <template slot="act" slot-scope="item">
              <a-button-group>
                <a-button type="primary" icon="edit"
                  :disabled="loading.edit_id!='' || loading.del_id!='' || current!=1 || loading.steps || loading.add"
                  @click="handleEdit(item)">
                </a-button>
                <a-button type="danger" icon="close" 
                  :loading="loading.del_id!='' && loading.del_id==item.id"
                  :disabled="loading.del_id!='' && loading.del_id!=item.id || loading.edit_id!='' || current!=1 || loading.steps || loading.add" 
                  @click="handleDelete(item)">
                </a-button>
              </a-button-group>
            </template>
          </a-table>
        </a-card>
      </a-col>
    </a-row>

    <Collective v-if="isCollective" :close="handleCloseCollective">
      <div slot="title">
        <a-icon type="edit" />&nbsp;Edit Collective
      </div>
      <template slot="content">
        <a-form class="margin-bottom" :form="formCollective">
          <a-row :gutter="16">
            <a-col :span="8">
              <a-form-item label="Budget Type">
                  <a-radio-group
                    v-decorator="[
                      'budget_type',
                      {
                        rules: [{ required: true }],
                        initialValue: 'COST_CENTER',
                      },
                    ]"
                    ref="refbudget_type_collective"
                    button-style="solid"
                    disabled
                  >
                    <a-radio-button value="SPPD">SPPD</a-radio-button>
                    <a-radio-button value="PP">PP</a-radio-button>
                    <a-radio-button value="COST_CENTER">COST CENTER</a-radio-button>
                  </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 8 }" :lg="{ span: 6 }">
              <a-form-item label="Is Commission?">
                <a-radio-group
                  v-decorator="[
                    'iscommision',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  @change="handleOptionCommission"
                  :disabled="EnCommission"
                  button-style="solid"
                >
                  <a-radio-button value="1"> Yes </a-radio-button>
                  <a-radio-button value="0"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :xs="{ span: 8 }" :lg="{ span: 6 }">
              <!-- <a-form-item label="With Note?" :hidden="Viwithout_note"> -->
                <a-form-item label="With Note?" :hidden="true">
                <a-radio-group
                  v-decorator="[
                    'without_note',
                    { rules: [{ required: false }], initialValue: '0' },
                  ]"
                  button-style="solid"
                >
                  <a-radio-button value="0"> Yes </a-radio-button>
                  <a-radio-button value="1"> No </a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="16">
            <a-col :span="8">
              <!-- <a-form-item label="SPPD No" v-if="!$refs.refbudget_type_collective || ($refs && $refs.refbudget_type_collective && $refs.refbudget_type_collective.value=='SPPD')">
                <a-select
                  showSearch
                  allowClear
                  :not-found-content="null"
                  option-filter-prop="children"
                  v-decorator="['sppd_no', { rules: [{ required: true }], initialValue: initialData.sppd_no}]"
                  :default-active-first-option="false"
                  :filter-option="filterOption"
                  @change="handlechangeSPPD"
                  placeholder="Type to Search"
                >
                  <a-select-option v-for="item in baseData.sppd" :key="item.id_sppd">
                    {{item.no_sppd}}
                  </a-select-option>
                </a-select>
              </a-form-item>
              <a-form-item label="PP No" v-if="$refs && $refs.refbudget_type_collective && $refs.refbudget_type_collective.value=='PP'">
                <a-select
                  showSearch
                  allowClear
                  :not-found-content="null"
                  option-filter-prop="children"
                  :default-active-first-option="false"
                  :filter-option="filterOption"
                  @change="handlechangePP"
                  v-decorator="['pp_no', { rules: [{ required: true }], initialValue: initialData.id_pp}]"
                  placeholder="Type to Search"
                >
                  <a-select-option v-for="item in baseData.pp" :key="item.id_pp">
                    {{item.no_pp}}
                  </a-select-option>
                </a-select>
              </a-form-item> -->
              <a-form-item label="Cost Center" v-if="$refs && $refs.refbudget_type_collective && $refs.refbudget_type_collective.value=='COST_CENTER'">
                <a-select
                  showSearch
                  allowClear
                  ref="refCostCenter"
                  :not-found-content="null"
                  option-filter-prop="children"
                  :default-active-first-option="false"
                  :filter-option="filterOption"
                  @change="handlechangeCostCenter"
                  v-decorator="['cost_center', { rules: [{ required: true }], initialValue: undefined}]"
                  placeholder="Type to Search"
                >
                  <a-select-option v-for="item in baseData.cost_center" :key="item.value">
                    {{item.jns_anggaran_id}} / {{item.text}} / {{ item.nama_pekerjaan }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Peruntukan" v-if="$refs && $refs.refbudget_type_collective && $refs.refbudget_type_collective.value=='COST_CENTER'">
                <a-select
                  showSearch
                  allowClear
                  :not-found-content="null"
                  option-filter-prop="children"
                  :default-active-first-option="false"
                  :filter-option="filterOption"
                  @change="handlechangePeruntukan"
                  v-decorator="['peruntukan', { rules: [{ required: true }], initialValue: undefined}]"
                  placeholder="Type to Search"
                >
                  <a-select-option v-for="item in peruntukan_list" :key="item.value">
                    {{item.text}}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Kode Anggaran">
                <a-tree-select
                  v-decorator="[
                    'kode_anggaran',
                    { rules: [{ required: true }], initialValue: undefined },
                  ]"
                  show-search
                  style="width: 100%"
                  :dropdown-style="{ maxWidth: '100%', maxHeight: '400px' }"
                  :tree-data="treeAnggaran"
                  treeNodeFilterProp="children"
                  :filterTreeNode="filterTreeNode"
                  placeholder="Please select"
                  allow-clear
                  :treeExpandedKeys="treeExpandedKeys"
                  :disabled="loading.tree"
                >
                  <div slot="title" slot-scope="item">
                    <div class="tree-between">
                      <div class="m-text-dots full">
                        <span>{{ item.texttitle }}</span>
                        <small> ({{ item.kode_anggaran }})</small>
                        <small> - {{ formatRupiah(item.anggaran_value) }}</small>
                      </div>
                    </div>
                  </div>
                  <template slot="suffixIcon">
                    <a-icon :type="loading.tree ? 'loading' : 'down'" />
                  </template>
                </a-tree-select>
              </a-form-item>
            </a-col>
            <a-col :span="8">
              <a-form-item label="Prospect No" v-if="selectedAggaranId">
              <a-select
                showSearch
                :not-found-content="null"
                option-filter-prop="children"
                v-decorator="[
                  'prospek',
                  {
                    rules: [{ required: true }],
                  },
                ]"
              >
                <a-select-option
                  v-for="item in listProspect"
                  :key="item.id_prospek"
                >
                  {{ item.no_prospek }} - {{ item.description }}
                </a-select-option>
              </a-select>
            </a-form-item>
            </a-col>
          </a-row>
        </a-form>
        <a-table
          :rowKey="(record, index) => {return index;}"
          :columns="columns"
          :dataSource="reportingCalc"
          :pagination="pagination_rptdtl"
          size="small"
          class="flex-1"
          :scroll="{ x: 1500 }"
          :loading="loadingTable"
          bordered
        >
          <template slot="customTitle">
            {{this.isCollective ? "Check" : "Action"}}&nbsp;
            <a-checkbox v-if="isCollective" v-model="checkAllCollective" @change="onCheckAllChange">
            </a-checkbox>
          </template>
          <template slot="title">
            <div class="search-wrapper" style="text-align:right">
              <a-input-search
                v-model="searchCollective"
                @change="onSearchCollective"
                placeholder="Search... "
                :style="getScreen ? 'width:100%' : 'width:30%'"
                :loading="timer.loadingcollective"
              >
              </a-input-search>
            </div>
          </template>
          <template slot="act" slot-scope="index, item">
            <a-checkbox
              v-if="item.edit_hapus ? item.edit_hapus!='0' : item.credit"
              :checked="selected.filter(obj => obj.id == item.id).length == 0 ? false : true"
              @change="handleCheck"
              :value="item"
            />
          </template>
          <template slot="no" slot-scope="text, item, index">
              {{(pagination.page - 1) * pagination.pageSize + index + 1}}
            </template>
            <template slot="dt" slot-scope="item">
              {{ moment(item.expense_date).format(getDefaultDateFormat) }}
            </template>
            <template slot="tun" slot-scope="item">
              {{ item.type_ticket }} | {{ item.user_booking }} | {{ item.no_booking }}
            </template>
            <template slot="val" slot-scope="item">
              <CurrencyJustified
                :currencyValue="'IDR'"
                :valueNumber="item.credit"
              />
            </template>
            <template slot="bspc" slot-scope="item">
              <div v-if="item.no_sppd" :style="!item.kode_anggaran ? 'color:red!important' : ''" >SPPD : {{ item.no_sppd }}</div>
              <div v-else-if="item.no_pp" :style="!item.kode_anggaran ? 'color:red!important' : ''" >PP : {{ item.no_pp }}</div>
              <div v-else-if="!item.no_sppd && !item.no_pp && item.kode_anggaran" :style="!item.kode_anggaran ? 'color:red!important' : ''">ANGGARAN : {{ item.kode_anggaran }}</div>
              <div v-else class="w-full m-text-align center"><b style="color:red">Not Set</b></div>

              <div v-if="item.no_sppd || item.no_pp" :style="!item.kode_anggaran ? 'color:red!important' : ''"><small><i>Anggaran : {{ item.kode_anggaran }}</i></small></div>
              <div v-if="!item.no_sppd && !item.no_pp && item.kode_anggaran && item.no_prospek" :style="!item.kode_anggaran ? 'color:red!important' : ''"><small><i>Prospek : {{ item.no_prospek }} - {{ item.description_prospek }}</i></small></div>
            </template>
            <template slot="ic" slot-scope="item">
              {{ item.iscommision=='1'?'Yes':'No' }}
            </template>
            <template slot="doc" slot-scope="item">
              <a-button type="default" size="small" v-if="item.lampiran" @click="handleViewDoc(item.lampiran_path)"><a-icon type="eye" />&nbsp;View</a-button>
              <span v-else>{{item.lampiran_path}}</span>
            </template>
            <template slot="desc" slot-scope="item">
              {{item.description}} ({{ lbltype_Item(item.type_item) }})
            </template>
        </a-table>
      </template>
      <a-button-group slot="action">
        <a-button @click="handleSet" :loading="loading.setCollective" type="primary" :disabled="selected.length == 0">Set</a-button>
        <a-button @click="handleCloseCollective" :disabled="loading.setCollective" :type="selected.length == 0 ? 'primary' : ''">Done</a-button>
      </a-button-group>
    </Collective>
  </a-card>
</template>

<script>
import { mapGetters } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import moment from "moment";
import _ from "lodash";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Information from "./steps/Information.vue";
import Usage from "./steps/Usage.vue";
import Approval from "./steps/Approval.vue";
import Collective from "@/components/collective/Collective.vue";
import collectiveTraveloka from "@/mixins/collective/collectiveTraveloka";

export default {
  name: "travelokaCreate",
  components: {
    Information, Usage, Approval, Collective
  },
  mixins: [GlobalMethod, CurrencyFormat, collectiveTraveloka],
  props: {
    id: String,
  },
  data() {
    return {
      mode: "Create",
      id_draft: null,
      loading:{
        steps: false,
        add: false,
        dtl: false,
        submit: false,
        edit_id: '',
        del_id: '',
        tree: false,
        setCollective: false,
        combo_prospect: false,
      },
      current: 0,
      steps: [
        {
          title: "Information",
          content: "Information",
        },
        {
          title: "Usage",
          content: "Usage",
        },
        {
          title: "Approval",
          content: "Approval",
        },
      ],
      collectData: {
        information: [],
        usage: [],
        usage_edited: [],
        approval: []
      },
      leftcolumn: 12,
      rightcolumn: 12,
      labelExpand: "Expand",
      pagination: {
        onChange: (page) => { this.pagination.page = page},
        page: 1,
        pageSize: 15,
        size: "small",
      },
      baseData: [],
      treeAnggaran: [],
      treeExpandedKeys: [],
      listAppr: [],
      EnCommission: false,
      Viwithout_note: true,
      searchCollective:'',
      checkAllCollective: false,
      timer: {
        collective: null,
        loadingcollective: false,
      },
      pagination_rptdtl: {
        onChange: (page) => { 
          this.pagination_rptdtl.page = page; 
        },
        page: 1,
        pageSize: 5,
        size: "small",
      },
      loadingTable: false,
      peruntukan_list: [],
      listProspect: [],
      selectedAggaranId: null
    }
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getAllKaryawan",
      "getAllMataUang",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    stepRef: function() {
      if (this.steps[this.current].content === "Information") {
        return "refInformation";
      } else if (this.steps[this.current].content === "Usage") {
        return "refUsage";
      } else{
        return "refApproval";
      }
    },
    stepProps: function() {
      if (this.steps[this.current].content === "Information") {
        return {
          collectData: this.collectData,
          baseData: this.baseData,
          mode: this.mode,
        };
      } else if (this.steps[this.current].content === "Usage") {
        return {
          collectData: this.collectData,
          baseData: this.baseData,
          treeAnggaran: this.treeAnggaran,
          treeExpandedKeys: this.treeExpandedKeys,
          id: this.id || this.id_draft,
          mode: this.mode,
          loadingPage: this.loading.add,
          listProspect: this.listProspect,
          loading_combo_prospect: this.loading.combo_prospect
        };
      } else {
          return {
            collectData: this.collectData,
            mode: this.mode,
            listAppr: this.listAppr.data,
            approval: this.listAppr.approval,
            id: this.id
          };
        }
    },
    columns(){
      return [
        {
          title: "No",
          key: "no",
          width:"50px",
          align:"right",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Date",
          key: "date",
          width: "100px",
          align:"center",
          scopedSlots: { customRender: "dt" },
        },
        {
          title: "Type Ticket | User Booking | No Booking",
          key: "tun",
          scopedSlots: { customRender: "tun" },
        },
        {
          title: "Description",
          key: "desc",
          width: "250px",
          align:"left",
          scopedSlots: { customRender: "desc" },
        },
        // {
        //   title: "Type Item",
        //   key: "typeItem",
        //   width: "100px",
        //   scopedSlots: { customRender: "typeItem" },
        // },
        {
          title: "Value",
          key: "val",
          width: "200px",
          scopedSlots: { customRender: "val" },
        },
        {
          title: "Budget (SPPD|PP|Cost Center)",
          key: "bspc",
          scopedSlots: { customRender: "bspc" },
        },
        {
          title: "is Commision",
          key: "ic",
          width: "120px",
          scopedSlots: { customRender: "ic" },
        },
        {
          title: "Document",
          key: "doc",
          width: "150px",
          scopedSlots: { customRender: "doc" },
        },
        {
          slots: { title: 'customTitle' },
          key: "act",
          fixed:'right',
          align: "center",
          width: this.isCollective ? 90 : 110,
          scopedSlots: { customRender: "act" },
        },
      ]
    },
    loading_action(){
      return  this.loading.del_id!='' || this.loading.edit_id!=''
    },
    reportingCalc() {
      let data = this.searchCollective ? 
        _.filter(this.collectData.usage, (e) =>  
          (e.type_ticket && e.type_ticket.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.user_booking && e.user_booking.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.no_booking && e.no_booking.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.no_sppd && e.no_sppd.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.no_pp && e.no_pp.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.kode_anggaran && e.kode_anggaran.toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          ((!e.no_sppd && !e.no_pp && !e.kode_anggaran ? 'Not Set' : '').toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.iscommision && (e.iscommision=='1'?'Yes':'No').toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.credit && (this.formatRupiah(e.credit)).toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) ||
          (e.expense_date && moment(e.expense_date).format(this.getDefaultDateFormat).toLowerCase().indexOf(this.searchCollective.toLowerCase()) >= 0) )
        : this.collectData.usage
      //console.log(data)
      let debit = 0;
      if (data) {
        data.forEach((value, index) => {
          if (value.debit !== "") {
            debit += value.debit;
            data[index]["debit_value"] = this.formatCurrency(
              this.mata_uang,
              value.debit
            );
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["debit_value"] = "-";
          }

          if (value.kredit !== "") {
            data[index]["kredit_value"] = this.formatCurrency(
              this.mata_uang,
              value.kredit
            );
            debit = debit - value.kredit;
            data[index]["sisa"] = this.formatCurrency(this.mata_uang, debit);
          } else {
            data[index]["kredit_value"] = "-";
          }
          data[index]["tanggal"] = moment(
            value.tanggal_pemakaian,
            this.getStandartFormatDate
          ).format(this.getDefaultDateFormat);
          data[index]["iscommision"] = value.iscommision;
          data[index]["without_note"] = value.without_note;
        });
      }
      return data;
    },
  },
  mounted(){
    Event.$on("collectTraveloka", this.valueFromChild);
    Event.$on("treeAggTraveloka", this.fetchTreeAnggaran);
    Event.$on("addDtlTraveloka", this.handleAddDtlProcess);
    Event.$on("changeDtlTraveloka", this.handleChangeProcess);
    Event.$on("stsuploadTravelokaFiles", this.stsuploadTravelokaFiles);
    Event.$on("getProspectList", this.getProspectList);
    Event.$on("handleUploadCsv", this.handleUploadCsv);
    this.fetchbaseData();

    if(this.$route.meta.draft || this.$route.meta.revise){
      this.fetchUsageList(this.id)
      .then((response)=>{
        if(response){
          this.mode = this.$route.meta.draft ? 'Draft' : (this.$route.meta.revise ? 'Revise' : 'Create')
          this.collectData.information = response
        }
      })
    }
  },
  beforeDestroy() {
    Event.$off("collectTraveloka", this.valueFromChild);
    Event.$off("treeAggTraveloka", this.fetchTreeAnggaran);
    Event.$off("addDtlTraveloka", this.handleAddDtlProcess);
    Event.$off("changeDtlTraveloka", this.handleChangeProcess);
    Event.$off("stsuploadTravelokaFiles", this.stsuploadTravelokaFiles);
    Event.$off("getProspectList", this.getProspectList);
    Event.$off("handleUploadCsv", this.handleUploadCsv);
  },
  methods: {
    moment,
    handleExpand() {
      if (this.leftcolumn == 12 && this.rightcolumn == 12) {
        this.leftcolumn = 0;
        this.rightcolumn = 24;
        this.labelExpand = "Collapse";
        //  this.pagination.pageSize = 10;
      } else {
        this.leftcolumn = 12;
        this.rightcolumn = 12;
        this.labelExpand = "Expand";
        // this.pagination.pageSize = 5;
      }
    },
    async fetchbaseData(){
      await this.asyncAxiosGet(
          "klaim_tiket/combo",
          this.getAuth,
          {}
      ).then((response) => {
        this.baseData = response
      })
    },
    async fetchTreeAnggaran(val){
      let data_ = {}
      if(val.sppd_no){
        data_ = {
          sppd_no: val.sppd_no
        }
      }else if(val.pp_no){
        data_ = {
          pp_no: val.pp_no
        }
      }else{
        data_ = {
          anggaran_id: val.anggaran_id,
          peruntukan_id: val.peruntukan_id
        }
      }

      if(this.isCollective){
        this.loading.tree = true
      }else{
        this.$refs.refUsage.setloadingTree(true)
      }
      await this.asyncAxiosGet(
          "klaim_tiket/item_anggaran",
          this.getAuth,
          data_
      ).then((response) => {
        this.treeAnggaran = response.data
        this.treeExpandedKeys = this.getParent(this.treeAnggaran);

        if(this.isCollective){
          this.loading.tree = false
        }else{
          this.$refs.refUsage.setloadingTree(false)
        }
      })
    },
    async fetchUsageList(){
      let information_headers_ = null;
      this.loading.dtl = true;
      await this.asyncAxiosGet(
          this.$route.meta.revise ? "klaim_tiket/dtl_revisi" : "klaim_tiket/dtl_draft",
          this.getAuth,
          {
            id_laporan: this.id || this.id_draft
          }
      ).then((response) => {
        information_headers_ = {
          report_date: response.report_date,
          id_user_cc: response.id_user_cc,
          note: response.note ? response.note : null
        }
        this.collectData.usage = response.detail_pemakaian
        this.loading.dtl = false;
        this.loading.add = false
      })
      return information_headers_
    },
    getParent(root) {
      let data = [];
      root.forEach((item) => {
        if (item.key) {
          data.push(item.key);
        }

        if (item.children.length > 0) {
          item.children.forEach((d) => {
            data.push(d.key);
          });
        }
      });
      return data;
    },
    async getListApproval(){
      this.loading.steps = true
      await this.asyncAxiosGet(
          "klaim_tiket/approval",
          this.getAuth,
          {
            id_laporan: this.id || this.id_draft
          }
      ).then((response) => {
        this.listAppr = response
        this.loading.steps = false
      })
    },
    valueFromChild(value) {
      if (this.steps[this.current].content === "Information") {
        if(this.mode=='Revise'){
          value['note'] = this.collectData.information.note
        }
        this.collectData.information = value;
        this.current++;
      } else if (this.steps[this.current].content === "Approval"){
        this.collectData.approval.note = value.note;
        this.collectData.approval.supervisor = value.approval;

        const that = this;
        this.$confirm({
        title: "Are you sure to save this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.saveTransProcess();
        },
        onCancel() {
        },
      })
      }
    },
    prev(){
      if (this.steps[this.current].content != "Information") {
        this.current--;
        if(this.steps[this.current].content == "Usage"){
          this.hidden_reportingDtl()
        }
      }
    },
    next(){
      if (this.steps[this.current].content === "Information") {
        this.$refs.refInformation.handleRef();
      }else if(this.steps[this.current].content === "Usage"){
        if(this.collectData.usage.length==0){
          this.displayMessageValue("error-other", "Reporting Details Can't be empty!");
        }else{
          const aggNull = this.collectData.usage.some(item => item.kode_anggaran === null)
          if(aggNull){
            this.displayMessageValue("error-other", "Some budget items remain empty, please set before next steps!");
            return;
          }

          this.getListApproval().then(()=>{
            this.current++;
            this.hidden_reportingDtl()
          })
        }
      }
    },
    saveTrans(){
      this.$refs.refApproval.handleRef();
    },
    saveTransProcess(){
      this.loading.steps = true

      let formData = new FormData();
      formData.append("id_laporan", this.id || this.id_draft);
      formData.append("id_user_cc", this.collectData.information.id_user_cc);
      formData.append("note", this.collectData.approval.note ? this.collectData.approval.note : null);
      formData.append("approval", this.collectData.approval.supervisor);

      let paramdata = {
        id_laporan: this.id || this.id_draft,
        id_user_cc: this.collectData.information.id_user_cc,
        note: this.collectData.approval.note ? this.collectData.approval.note : null,
        approval: this.collectData.approval.supervisor
      }

      const x_action = (
        this.$route.meta.revise ?
        this.asyncAxiosPut(
          "klaim_tiket",
          "application/json",
          this.getAuth,
          paramdata
        )
        :
        this.asyncAxiosPost(
          "klaim_tiket",
          "formdata",
          this.getAuth,
          formData
        )
      )
      
      x_action.then(() => {
        this.$router.push({ name: "travelokaklaimManifest", params: { id: this.$route.meta.revise ? this.id : this.collectData.usage[0].id_laporan } });
      })
      .catch((error) => {
        this.loading.steps = false
        
        let responses = Object.assign({}, error);
        console.log(responses)
        if (responses.response.data) {
          this.displayMessageValue(
            "error-other",
            responses.response.data.message
          );
        } else {
          this.displayMessageValue("error-other", responses.response);
        }
      });
    },
    handleAddDtl(){
      this.$refs.refUsage.handleRef();
    },
    handleAddDtlProcess(data){
      this.loading.add = true
      this.asyncAxiosPost(
        this.$route.meta.revise ? "klaim_tiket/dtl_revisi" : "klaim_tiket/dtl_draft",
        "formdata",
        this.getAuth,
        data
      )
      .then((response) => {
        this.id_draft = response.id_laporan
        this.fetchUsageList()
        .then(()=>{
          this.collectData.usage = response.detail_pemakaian
          this.loading.add = false
          this.$refs.refUsage.resetForm()
        })
      })
      .catch((error) => {
        this.loading.add = false
        let responses = Object.assign({}, error);
        if (responses.response.data) {
          this.displayMessageValue(
            "error-other",
            responses.response.data.message
          );
        } else {
          this.displayMessageValue("error-other", responses.response);
        }
      });
    },
    handleUploadCsv(id){
      this.id_draft = id
      this.fetchUsageList()
    },
    handleViewDoc(doc_path){
      window.open(this.$serviceUrl + doc_path, "_blank");
    },
    handleEdit(item){
      this.$refs.refUsage.resetForm()
      if(item.sppd_no){
        this.$refs.refUsage.handlechangeSPPD(item.sppd_no)
      }else if(item.pp_no){
        this.$refs.refUsage.handlechangePP(item.pp_no)
      }else{
        this.$refs.refUsage.handlechangeCostCenter(item.anggaran_id)
      }
      
      if(item.peruntukan_id) this.$refs.refUsage.handlechangePeruntukan_modeEdit(item)
      if(item.lampiran) this.$refs.refUsage.handlingBinaryFiles(item)

      
      this.collectData.usage_edited = item
      this.loading.edit_id = item.id
    },
    handleChange(){
      this.$refs.refUsage.handleRef()
    },
    handleChangeProcess(data){
      this.loading.add = true
      this.asyncAxiosPost(
        this.$route.meta.revise ? "klaim_tiket/dtl_revisi_edit" : "klaim_tiket/dtl_draft_edit",
        "formdata",
        this.getAuth,
        data
      )
      .then((response) => {
        this.id_draft = response.id_laporan
        this.fetchUsageList()
        .then(()=>{
          this.collectData.usage = response.detail_pemakaian
          this.loading.add = false
          this.loading.edit_id = ''
          this.collectData.usage_edited = []
          this.$refs.refUsage.resetForm()
        })
      })
      .catch((error) => {
        this.loading.add = false
        let responses = Object.assign({}, error);
        if (responses.response.data) {
          this.displayMessageValue(
            "error-other",
            responses.response.data.message
          );
        } else {
          this.displayMessageValue("error-other", responses.response);
        }
      });
    },
    handleCancel(){
      this.collectData.usage_edited = []
      this.$refs.refUsage.resetForm()
      this.loading.edit_id = '';
    },
    handleDelete(item){
      const that = this

      if(this.collectData.usage.length==1){
        this.displayMessageValue("error-other", "Can't be deleting..., At least one data point is required!");
        return;
      }

      this.$confirm({
        title: "Are you sure to delete this data?",
        content: "",
        okText: "Yes",
        cancelText: "No",
        onOk() {
          that.loading.del_id = item.id;

          that.asyncAxiosDelete(
            that.$route.meta.revise ? "klaim_tiket/dtl_revisi" : "klaim_tiket/dtl_draft",
            "application/json",
            that.getAuth,
            { id: item.id }
          ).then(() => {
            that.loading.del_id = ''
            that.displayMessage("success-del");
            that.fetchUsageList()
          }).catch((err) => {
            console.log(err);
            that.loading.del_id = ''
          });
        },
        onCancel() {
        },
      })
    },
    hidden_reportingDtl(){
      this.rightcolumn = this.steps[this.current].content == "Approval" ? 0 :12
      this.leftcolumn = this.steps[this.current].content == "Approval" ? 24 :12
    },
    stsuploadTravelokaFiles(val){
      this.loading.add = val
    },
    lbltype_Item(val){
      let result = "";
      switch(val) {
			case '1':
				result = "Tiket"
				break;
      case '2':
				result = "Jasa"
				break;
      case '3':
				result = "PPN"
				break;
      case '4':
				result = "PPH 23"
				break;
      case '5':
				result = "Refund"
				break;
			default: result = val.toUpperCase(); break;
      }
      return result;
    },
    async getProspectList(val){
      this.loading.combo_prospect = true;
      await this.asyncAxiosGet(
        "prospek/pilih_prospek",
        this.getAuth,
        {
          anggaran_id: val.anggaran_id
        }
      ).then(async (response) => {
        this.listProspect = response.data ? response.data : [];
        this.loading.combo_prospect = false;
      })
      .catch(() => {
      });
    },
    handlechangeCostCenter(val){
      const ls_dt = _.filter(this.baseData.cost_center, item=>item.value == val);
      this.selectedAggaranId = ls_dt.length > 0 ? (ls_dt[0].jns_anggaran_id=='07' ? '07' : null) : null;
      if(this.selectedAggaranId) Event.$emit("getProspectList", {anggaran_id: val});
    }
  }
}
</script>